var $ = require('jquery');
require('jquery-ui');   

var AriesComponent = require('libs/aries-component');

module.exports = {
 sendVerificationHandler: function _sendVerificationHandler(event) {
    var _self = this,
	isResFlow = false;
	 if($('.js-verify-and-enroll-form').length) {
	 	isResFlow = true;
	 }
    var ajaxurl = isResFlow? $('.js-verify-and-enroll-form').data('resend-code-ajaxurl') : $('.tile-enrollmentForm-sendVerification').data('ajaxurl');
    var data = {};    
    data.context = _self.getContextData();    
    data.sessionToken = _self.getSessionToken();    
    data.sourceURI = _self.getSourceURI();    
    data.variation = _self.getVariation();    
    data.context.success = true;    
    data.context.mobileTelephone = $('#field-telephone-number').val();      
    data.context.otpRequest = !isResFlow;            
    data.context.resResendOtpRequest = isResFlow;      
    data.context.mobileCountryPrefixCode = $('#mobilePhoneDropdownList').val();      
    data.context.countryCode =  $('#field-country').val();
    _self.makeAjaxCall({
        url: ajaxurl,
        method: "POST",
        data: JSON.stringify(data),
        success: function (data) {
            var response = data.component.data;
	    if($('.js-verify-and-enroll-form').length){
	    	var otpTransactionId = $('.js-otp-transactionId');
		otpTransactionId.val(response.otpTransactionid);
	    }
            else if(response.isError && (response.errorMessageKeys[0] || response.errorMessagesList[0])) {		    
              var errorMsgContainer = $('.tile-message-box');
                  errorMsgContainer.remove();
              var errorMsg = '<div class="tile-message-box l-enroll-border-none  message-box m-message-box m-message-box-error t-font-s t-error-message l-margin-double-bottom js-custom-message-box l-s-col-4 l-s-col-last l-m-col-8 l-m-col-last l-l-col-6 l-xl-col-6" tabindex="0" role="alert"><p class="message-title t-font-m t-font-weight-semibold l-margin-none">' +response.messageTitle+ '</p>';
              for(var i in response.errorMessageKeys){
				errorMsg = errorMsg + '<span class="message-items t-message">' +response[response.errorMessageKeys[i]]+ '</span>'
              }
              for(var i in response.errorMessagesList) {
                errorMsg = errorMsg + '<span class="message-items t-message">' +response.errorMessagesList[i]+ '</span>'
              }
              errorMsg = errorMsg + '</div>'
              if($("div").hasClass("js-enrollmentForm")){
                $('.js-enrollmentForm').prepend(errorMsg);	
              }else{
                $('.tile-enrollment-form').closest('section > div').prepend(errorMsg);
              }
              $('.js-send-verification-code-btn').removeClass("is-disabled t-cursor-default").prop("disabled", false);
              $('.js-field-number').addClass('is-error');
		    $('html,body').scrollTop(0);
            }
            else {
              var otpFlowToggle = $('.js-otp-flow-toggle,.js-otp-flow-toggle-pwd'),                            
              otpFlowToggleText = $('.js-otp-flow-toggle-text'),
              otpLink = $('.js-resend-code'),
              otpSendCheck = $('.js-otp-send-check'),
              otpSend = $('.js-otp-send'),
              otpTransactionId = $('.js-otp-transactionId'),
              sendVerificationBtn = $('.js-send-verification-code-btn');
              otpLink.removeClass('l-resend-code');
              otpFlowToggle.removeClass('is-disabled').prop("disabled",false);
              otpSendCheck.show();
              $('.js-custom-message-box').remove();
              $('.js-field-number').removeClass('is-error');
              sendVerificationBtn.addClass("is-disabled t-cursor-default").prop("disabled", true);
              // To map OTP and transactionId
              otpTransactionId.val(response.otpTransactionid);
          }
             
        }
    });
  }
}
